var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.commentsMapped),function(item){return _c('CommentListItem',{key:item.id,staticClass:"mt-5",attrs:{"item":item,"is-html":_vm.isHtml,"is-on-talent-side":_vm.isOnTalentSide}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }